export default __webpack_public_path__ + "static/logo-1-ecf7cb9944ee92aa8a94fba3d4b3a4a4.webp";